import { IPurchase } from "@stores/purchases/types";

export function getPurchaseCardId({ id }: Pick<IPurchase, "id">): string {
  return `purchase-${id}`;
}
